export default "__VITE_ASSET__DMI_YT9n__"